import { Injectable } from '@angular/core';
import { RequestService } from '@core/services/request/request.service';
import { SpendingTrendsApiFilter, SpendingTrendsApiResponse } from '@core/api/model/consumption/spending-trends-api.model';
import { ApiDirectory } from '@core/api/api-directory';
import { HttpParamsService } from '@core/services/http-params/http-params.service';
import { Observable } from 'rxjs';
import { RequestResponse } from '@core/services/request/model/request.model';
import { LoadingIds } from '@shared/constants/loading';
import {
  AccumulatedConsumptionApi,
  ConsumptionFilterApi,
  YearlyAccumulatedConsumptionApi,
} from '@core/api/model/consumption/consumption-api.model';

@Injectable({
  providedIn: 'root',
})
export class ApiSpendingService {
  constructor(
    private readonly _requestService: RequestService,
    private readonly _httpParamsService: HttpParamsService
  ) {}

  public getSpending(filter: SpendingTrendsApiFilter): Observable<RequestResponse<SpendingTrendsApiResponse>> {
    return this._requestService.get(ApiDirectory.Consumo.Gasto({}), {
      params: this._httpParamsService.toParams(filter),
      loading: LoadingIds.FETCH_SPENDING_TRENDS_SPENDING,
      hideErrorAlert: true,
    });
  }

  public getAccumulatedConsumption(
    filter: ConsumptionFilterApi
  ): Observable<RequestResponse<AccumulatedConsumptionApi<YearlyAccumulatedConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.Consumo.AcumuladoAnual({}), {
      params: this._httpParamsService.toParams(filter),
      loading: LoadingIds.FETCH_SPENDING_TRENDS_CONSUMPTIONS,
      hideErrorAlert: true,
    });
  }
}
